import React from 'react';

import classes from './BuildControl.module.css';

const BuildControl = (props) => {
	return (
		<div className={classes.BuildControl}>
			<p className={classes.label}>{props.label}</p>
			<button
				className={classes.Less}
				onClick={props.decrease}
				disabled={props.disabled}
			>
				Less (-)
			</button>
			<button className={classes.More} onClick={props.increase}>
				More (+)
			</button>
		</div>
	);
};

export default BuildControl;
